import { confirmAlert } from 'react-confirm-alert';

import type { ListId } from '@vlabs/api/artemy/model';

import { DetachCardFromListConfirmationPoint3 } from './DetachCardFromListConfirmation.point3';

interface ConfirmDetachFromListProps {
  listId: ListId;
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
  async?: boolean;
}

export const confirmDetachCardFromListPoint3 = ({
  listId,
  onConfirm,
  onReject = undefined,
  async = false,
}: ConfirmDetachFromListProps): void | Promise<void> => {
  const buildAlert = ($onConfirm?: VoidFunction, $onReject?: VoidFunction) => confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DetachCardFromListConfirmationPoint3
          listId={listId}
          onConfirm={() => {
            $onConfirm?.();
            onClose();
          }}
          onReject={() => {
            $onReject?.();
            onClose();
          }}
        />
      );
    },
  });
  if (!async) return void buildAlert(onConfirm, onReject);

  return new Promise((resolve, reject) => {
    const $onConfirm = () => {
      onConfirm?.();
      resolve();
    };
    const $onReject = () => {
      onReject?.();
      reject();
    };
    buildAlert($onConfirm, $onReject);
  });
};
